// (function () {
//   // Prevent double binding
//   if (window.hasBoundAllHoverEvents) return;
//   window.hasBoundAllHoverEvents = true;

//   console.log("Unified Video Script Active");

//   // Helper: Fast and safe video controls
//   const controlVideo = (video, action) => {
//     if (!video || typeof video.play !== 'function') return;
//     try {
//       if (action === 'play') {
//         video.muted = true;
//         video.currentTime = 0;
//         video.play().catch(() => {});
//       } else {
//         video.pause();
//         video.currentTime = 0;
//       }
//     } catch (e) {}
//   };

//   // Helper: Find item safely without throwing errors
//   const getContainer = (target) => {
//     // Only run .closest if target is an Element (Node Type 1)
//     if (target && target.nodeType === 1 && typeof target.closest === 'function') {
//       return target.closest('.product-item__link, .look-item');
//     }
//     return null;
//   };

//   // DESKTOP: Unified Mouse Events
//   document.addEventListener("mouseenter", (e) => {
//     const container = getContainer(e.target);
//     if (!container) return;

//     // Supports both Product Items and Lookbook Items
//     const video = container.querySelector('.product-item__video, .look-item__video video');
//     controlVideo(video, 'play');
//   }, true);

//   document.addEventListener("mouseleave", (e) => {
//     const container = getContainer(e.target);
//     if (!container) return;

//     const video = container.querySelector('.product-item__video, .look-item__video video');
//     controlVideo(video, 'pause');
//   }, true);

//   // MOBILE: Touch Logic
//   let activeCard = null;
//   document.addEventListener("touchstart", (e) => {
//     const container = getContainer(e.target);
//     if (!container) return;

//     activeCard = container;
//     container.classList.add('mobile-hover');
//     const video = container.querySelector('.product-item__video, .look-item__video video');
//     controlVideo(video, 'play');
//   }, { passive: true });

//   document.addEventListener("touchend", () => {
//     if (activeCard) {
//       activeCard.classList.remove('mobile-hover');
//       const video = activeCard.querySelector('.product-item__video, .look-item__video video');
//       controlVideo(video, 'pause');
//       activeCard = null;
//     }
//   });
// })();
(function () {
  if (window.hasBoundAllHoverEvents) return;
  window.hasBoundAllHoverEvents = true;

  const controlVideo = (video, action) => {
    // If the video is inside the swiper slider, we let autoplay handle it.
    if (!video || video.closest('swiper-container')) return;
    
    try {
      if (action === 'play') {
        video.muted = true;
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    } catch (e) {}
  };

  const getContainer = (target) => {
    if (target && target.nodeType === 1 && typeof target.closest === 'function') {
      return target.closest('.product-item__link, .look-item');
    }
    return null;
  };

  // Helper to find the Metafield video specifically (not the slider one)
  const getMetafieldVideo = (container) => {
    return container.querySelector('.product-item__video:not(swiper-slide video)');
  };

  document.addEventListener("touchstart", (e) => {
    const container = getContainer(e.target);
    if (!container) return;

    activeCard = container;
    container.classList.add('mobile-hover');
    
    const video = getMetafieldVideo(container);
    if (video) controlVideo(video, 'play');
  }, { passive: true });

  document.addEventListener("touchend", () => {
    if (activeCard) {
      activeCard.classList.remove('mobile-hover');
      const video = getMetafieldVideo(activeCard);
      if (video) controlVideo(video, 'pause');
      activeCard = null;
    }
  });

  // Keep Desktop Hover working too
  document.addEventListener("mouseenter", (e) => {
    const container = getContainer(e.target);
    if (container) controlVideo(getMetafieldVideo(container), 'play');
  }, true);

  document.addEventListener("mouseleave", (e) => {
    const container = getContainer(e.target);
    if (container) controlVideo(getMetafieldVideo(container), 'pause');
  }, true);
})();